import Component from './personal-info-form';
export default Component;
